import React from 'react';
import { 
  Box, 
  Typography, 
  Link, 
  Divider, 
  Button,
  Dialog, 
  DialogTitle, 
  DialogContent, 
  DialogActions, 
  IconButton 
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import SupportIcon from '@mui/icons-material/Support';
import PhoneIcon from '@mui/icons-material/Phone';
import EmailIcon from '@mui/icons-material/Email';

// As a standalone component, we need to receive props instead of using internal state
const ContactHelpModal = ({ open, onClose, venue }) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle sx={{ pb: 0 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <Typography variant="h6">Need Help?</Typography>
          <IconButton onClick={onClose} aria-label="close">
            <CloseIcon />
          </IconButton>
        </Box>
      </DialogTitle>
      <DialogContent>
        {venue && (
          <>
            <Box sx={{ mb: 3, mt: 1 }}>
              <Typography variant="subtitle1" fontWeight={600} sx={{ mb: 1 }}>
                Contact {venue.name}
              </Typography>
              
              {venue.contact_phone_1 && (
                <Box sx={{ display: 'flex', alignItems: 'center', mb: 1.5 }}>
                  <PhoneIcon fontSize="small" sx={{ color: 'primary.main', mr: 1.5 }} />
                  <Typography variant="body2">
                    <Link href={`tel:${venue.contact_phone_1}`} underline="hover">
                      {venue.contact_phone_1}
                    </Link>
                  </Typography>
                </Box>
              )}
              
              {venue.contact_email && (
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                  <EmailIcon fontSize="small" sx={{ color: 'primary.main', mr: 1.5 }} />
                  <Typography variant="body2">
                    <Link href={`mailto:${venue.contact_email}`} underline="hover">
                      {venue.contact_email}
                    </Link>
                  </Typography>
                </Box>
              )}
            </Box>
            
            <Divider sx={{ my: 3 }} />
            
            <Box>
              <Typography variant="subtitle1" fontWeight={600} sx={{ mb: 1 }}>
                HiveSpace Support
              </Typography>
              <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                If you need additional assistance, our support team is ready to help you.
              </Typography>
              
              <Box sx={{ display: 'flex', alignItems: 'center', mb: 1.5 }}>
                <EmailIcon fontSize="small" sx={{ color: 'primary.main', mr: 1.5 }} />
                <Typography variant="body2">
                  <Link href="mailto:hello@hivespace.co" underline="hover">
                    hello@hivespace.co
                  </Link>
                </Typography>
              </Box>
            </Box>
          </>
        )}
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 3 }}>
        <Button 
          variant="outlined" 
          onClick={onClose}
          startIcon={<ArrowBackIcon />}
        >
          Back to Booking
        </Button>
        <Button 
          variant="contained" 
          onClick={() => window.open('https://hivespace.co/contact', '_blank')}
          startIcon={<SupportIcon />}
        >
          Visit Help Center
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ContactHelpModal;